<template>
    <div class="lifecircle-container">
        <div class="lifecircle-container-body">
            <div class="lifecircle-head">
                <img :src="detail_data.avatar || default_pic" alt="">
                <div class="lifecircle-head-name">{{detail_data.nickname}}</div>
                <div class="lifecircle-head-follow">
                    <van-button color="linear-gradient(to right, #ff7641, #ff0b40)">
                        <span class="follow">关注</span>
                        <wxopenbtn type="life_circle_image_text" :postid="detail_data._id" />
                    </van-button>
                </div>
            </div>
            <div>
                <van-swipe class="lifecircle-swipe" :style="{'height': swiperMaxH + 'px'}" :show-indicators="false" :loop="false" @change="swiperChange">
                    <van-swipe-item @click="imgView" v-for="(item, index) in preview_list" :key="index">
                        <div class="swiper-item-wrap">
                            <van-image :src="item" />
                        </div>
                    </van-swipe-item>
                </van-swipe>
                <div v-show="preview_list.length >= 2" class="lifecircle-swiper-pointcontainer">
                    <div v-for="(item, index) in preview_list.length" :key="index" :class="{'point': true, 'active': index === swiper_index}" ></div>
                </div>
                <div v-show="share_data.goodsName" class="lifecircle-production">
                    <img class="lifecircle-production-lpic" :src="share_data.goodsImage" alt="">
                    <div class="lifecircle-production-content">{{share_data.goodsName}}</div>
                    <van-icon name="arrow" size="14" color="#dddddd" />
                </div>
                <div class="lifecircle-title">{{detail_data.title}}</div>
                <div class="lifecircle-datetime">{{formatTime(detail_data.release_time)}}</div>
                <div class="lifecircle-content">{{detail_data.content}}</div>
                <div class="lifecircle-function">
                    <div class="lifecircle-function-wrap">
                        <img class="lifecircle-function-dz" :src="dian_zan_pic" alt="">
                        <span>{{bigNumToSmall(detail_data.fabulous_count)}}</span>
                        <wxopenbtn type="life_circle_image_text" :postid="detail_data._id" />
                    </div>
                    <div class="lifecircle-function-wrap">
                        <img class="llifecircle-function-sc" :src="collection_pic" alt="">
                        <span>{{bigNumToSmall(detail_data.collection_count)}}</span>
                        <wxopenbtn type="life_circle_image_text" :postid="detail_data._id" />
                    </div>
                    <div class="lifecircle-function-wrap">
                        <img class="lifecircle-function-pl" :src="ping_lun_pic" alt="">
                        <span>{{bigNumToSmall(detail_data.comment_count)}}</span>
                        <wxopenbtn type="life_circle_image_text" :postid="detail_data._id" />
                    </div>
                </div>
                <waterlist type="life_circle_image_text" :postid="detail_data._id" />
            </div>
        </div>
        <openapp type="life_circle_image_text" :postid="detail_data._id" />
        <van-overlay :show="request_err" @click="request_err = false">
            <div class="overlay-wrapper" @click.stop>
                <img :src="load_err_png" alt="">
                <div class="overlay-error-text">请求失败</div>
                <div class="overlay-btn">
                    <van-button @click="reRequest" color="linear-gradient(to right, #ff7641, #ff0b40)">
                        <span class="follow">重新请求</span>
                    </van-button>
                </div>
            </div>
        </van-overlay>
    </div>
</template>

<script>
    import waterlist from "./water-list.vue";
    import { ImagePreview, Toast } from 'vant';
    import openapp from "./open-app.vue";
    import wxopenbtn from "./wxopenbtn.vue";
    const u = navigator.userAgent;
    let swiperHeight = 0;
    export default {
        components: {
            waterlist,
            openapp,
            wxopenbtn
        },
        data() {
            return {
                load_err_png: require("@/assets/lifecircle/load_err.png"),
                default_pic: require("@/assets/lifecircle/default.png"),
                production_pic: require("@/assets/lifecircle/production.png"),
                dian_zan_pic: require("@/assets/lifecircle/dian-zan.png"),
                collection_pic: require("@/assets/lifecircle/collection.png"),
                ping_lun_pic: require("@/assets/lifecircle/ping-lun.png"),
                logofill_pic: require("@/assets/lifecircle/logo-fill.png"),
                swiper_index: 0,
                swiperMaxH: 500,
                share_data: {},
                request_err: false,
                detail_data: {
                    nickname: "默认用户",
                    title: "",
                    content: "",
                    release_time: "",
                    avatar: ""
                },
                preview_list: []
            }
        },
        methods: {
            swiperChange(index){
                this.swiper_index = index;
            },
            bigNumToSmall(num){
                if(isNaN(Number(num))) return 0;
                const match = /(\d)+(\.+\d)?/;
                if (!num || num <=0) return 0;
                if (num < 10000) return num;
                const res = String(num/10000).match(match);
                if (res) {
                    return num >= 10000 ? `${res[0]}w` : num;
                }
                return num >= 10000 ? `${(num / 10000).toFixed(1)}w` : num;
            },
            computedImgH(list){
                list.forEach((item) => {
                    this.preview_list.push(item.url);
                    let hh = Math.floor((item.height || 1080) * 375 / (item.width || 375));
                    if (hh > 500) {
                        hh = 500;
                    }
                    swiperHeight = Math.max(hh, swiperHeight);
                });
                setTimeout(() => {
                    this.swiperMaxH = swiperHeight;
                });
            },
            formatTime(time) {
                return String(time).split(" ")[0].replace(/-/g, "/");
            },
            getDetailFn(){
                Toast.loading({
                    message: '加载中...',
                    forbidClick: true,
                    loadingType: 'spinner',
                });
                this.$api.post("/life-moments/index/dynamic/detail",{post_id: this.$route.query.post_id || ""}).then((res) => {
                    if (res.share) {
                        this.share_data = JSON.parse(res.share);
                    }
                    this.detail_data = res;
                    const img_list = res.img_video || [];
                    const swiper_list = [];
                    img_list.forEach(item => {
                        swiper_list.push(item.completeUrl);
                        let hh = Math.floor((item.height || 1080) * 375 / (item.width || 375));
                        if (hh > 500) {
                            hh = 500;
                        }
                        swiperHeight = Math.max(hh, swiperHeight);
                    });
                    setTimeout(() => {
                        this.request_err = false;
                        Toast.clear();
                        this.swiperMaxH = swiperHeight;
                        this.preview_list = swiper_list;   
                    });
                }).catch((err) => {
                    Toast.clear();
                    this.request_err = true;
                    if (err.response.data.data && err.response.data.data.post_id) {
                        Toast(err.response.data.data.post_id[0])
                    }else{
                        Toast("获取数据失败")
                    }
                });
            },
            reRequest(){
                this.getDetailFn();
            },
            imgView(){
                ImagePreview({
                    images: this.preview_list,
                    startPosition: this.swiper_index,
                    closeable: true
                });
            },
            wxConfig(){
                this.$api.post("member/index/wechat/get/sign/package",{
                    type: 2,
                    url: location.href
                }).then((res) => {
                    wx.config({
                        debug: false,
                        appId: res.appId,
                        nonceStr: res.nonceStr,
                        signature: res.signature,
                        timestamp: res.timestamp,
                        jsApiList: ["checkJsApi"],
                        openTagList: ["wx-open-launch-app"],
                    });
                }).catch((err) => {
                    
                });
            }
        },
        created() {
            if (u.toLowerCase().includes("micromessenger")) {
                this.wxConfig();
            }
            this.getDetailFn();
        }
    }
</script>

<style lang="less" scoped>
    .lifecircle-container{
        box-sizing: border-box;
        padding-bottom: 50px;
        background-color: #ffffff;
        .lifecircle-container-body{
            flex: 1;
            padding: 0 15px;
            overflow-y: auto;
        }
        .lifecircle-head{
            display: flex;
            align-items: center;
            height: 65px;
            img{
                width: 30px;
                height: 30px;
                border-radius: 50%;
            }
            .lifecircle-head-name{
                flex: 1;
                margin-left: 10px;
                font-size: 16px;
                font-family: PingFangSC, PingFangSC-Medium;
                font-weight: 500;
            }
            .lifecircle-head-follow{
                width: 57px;
                height: 30px;
                border-radius: 22px;
                overflow: hidden;
                .follow{
                    color: #ffffff;
                }
                .no-follow{
                    color: rgba(0,0,0,0.40);
                }
                &/deep/.van-button{
                    width: 57px;
                    height: 30px;
                    padding: 0;
                }
            }
        }
        .lifecircle-swipe{
            height: 400px;
            border-radius: 4px;
            .swiper-item-wrap{
                height: 100%;
                display: flex;
                justify-content: center;
                align-items: center;
            }
        }
        .lifecircle-swiper-pointcontainer{
            display: flex;
            justify-content: center;
            margin-top: 5px;
            .point{
                margin: 0 2px;
                width: 4px;
                height: 4px;
                background: rgba(0,0,0,0.40);
                border-radius: 2px;
                &.active{
                    background-color: #F84438;
                }
            }
        }
        .lifecircle-production{
            display: flex;
            align-items: center;
            margin-top: 15px;
            padding-right: 10px;
            height: 42px;
            background-color: #f5f6f8;
            .lifecircle-production-lpic{
                width: 42px;
                height: 42px;
                margin-right: 5px;
            }
            .lifecircle-production-content{
                flex: 1;
                font-size: 14px;
                font-family: PingFangSC, PingFangSC-Regular;
                color: #333333;
            }
            .lifecircle-production-rpic{
                margin-right: 10px;
                width: 14px;
                height: 14px;
            }
            
        }
        .lifecircle-title{
            margin: 12px 0;
            font-size: 16px;
            font-family: PingFangSC, PingFangSC-Medium;
            font-weight: 500;
            color: #333333;
        }
        .lifecircle-datetime{
            font-size: 12px;
            font-family: PingFangSC, PingFangSC-Medium;
            font-weight: 500;
            color: #999999;
        }
        .lifecircle-content{
            margin-top: 12px;
            font-size: 14px;
            font-family: PingFangSC, PingFangSC-Regular;
            color: #333333;
            line-height: 20px;
        }
        .lifecircle-function{
            display: flex;
            justify-content: flex-end;
            margin-top: 16px;
            margin-bottom: 40px;
            padding-bottom: 40px;
            border-bottom: 1px solid rgba(0,0,0,0.05);
            .lifecircle-function-wrap{
                position: relative;
                display: flex;
                align-items: center;
            }
            img{
                margin-left: 15px;
                margin-right: 5px;
                width: 18px;
                height: 18px;
            }
        }
        .overlay-wrapper{
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            height: 100%;
            background-color: #000000;
            .overlay-error-text{
                margin-top: 8px;
                color: #F84438;
                font-size: 12px;
                font-family: PingFangSC, PingFangSC-Regular;
            }
            img{
                width: 179px;
                height: 100px;
            }
            .overlay-btn{
                margin-top: 24px;
                width: 76px;
                height: 30px;
                border-radius: 22px;
                overflow: hidden;
                &/deep/.van-button{
                    width: 76px;
                    height: 30px;
                    padding: 0;
                }
            }
        }
    }
    
</style>